import { required, email } from 'vuelidate/lib/validators';
import abstractValidatorMixin from '../abstractValidator.mixin';

export default {
    mixins: [abstractValidatorMixin],

    data() {
        return {
            serverErrors: {
                firstName: [],
                lastName: [],
                phone: [],
                birthDate: [],
                email: []
            }
        };
    },

    validations: {
        formData: {
            firstName: { required },
            lastName: { required },
            phone: { required },
            birthDate: { required },
            email: { required, email }
        }
    },

    computed: {
        firstNameErrors() {
            return this.checkErrors(
                'firstName',
                'formData',
                'editUserInformation.validators.'
            );
        },
        lastNameErrors() {
            return this.checkErrors(
                'lastName',
                'formData',
                'editUserInformation.validators.'
            );
        },
        phoneErrors() {
            return this.checkErrors(
                'phone',
                'formData',
                'editUserInformation.validators.'
            );
        },
        birthDateErrors() {
            return this.checkErrors(
                'birthDate',
                'formData',
                'editUserInformation.validators.'
            );
        },
        emailErrors() {
            return this.checkErrors(
                'email',
                'formData',
                'editUserInformation.validators.'
            );
        }
    }
};
